import { combineReducers } from '@reduxjs/toolkit';

import { PreQualificationStep } from 'enums/PreQualificationStep';
import { SignInStep } from 'enums/SignInStep';
import store from 'store';

import accountReducer, { AccountActionType, setAccount } from './account';
import applicationReducer from './application';
import borrowerReducer from './borrower';
import coBorrowerReducer from './coBorrower';
import coOwnerInfoReducer from './coOwnerInfo';
import dashboardReducer from './dashboardPortal';
import dataReducer from './data';
import documentsReducer from './documents';
import incomeReducer from './income';
import loadingReducer, { setLoadingState, LoadingType } from './loading';
import prequalificationReducer from './prequalificationPortal';
import proveErrorInfoReducer from './proveErrorInfo';
import stagesReducer, { setPreQualificationStep, setSignInStep } from './stages';

const globalReducer = combineReducers({
  data: dataReducer,
  documents: documentsReducer,
  borrower: borrowerReducer,
  coBorrower: coBorrowerReducer,
  income: incomeReducer,
  stages: stagesReducer,
  application: applicationReducer,
  account: accountReducer,
  loading: loadingReducer,
  dashboardPortal: dashboardReducer,
  proveErrorInfo: proveErrorInfoReducer,
  prequalificationPortal: prequalificationReducer,
  coOwnerInfo: coOwnerInfoReducer,
});

export default globalReducer;

export type RootState = ReturnType<typeof globalReducer>;
export type AppDispatch = typeof store.dispatch;

export {
  setPreQualificationStep,
  PreQualificationStep,
  setSignInStep,
  SignInStep,
  AccountActionType,
  setLoadingState,
  LoadingType,
  setAccount,
};
